export const SUBSCRIPTION_LIGHTING_STORE = "LightingStore";
export const SUBSCRIPTION_STORE_STATUS = "StoreStatus";
export const SUBSCRIPTION_OPENING_HOURS = "OpeningHours";
export const SUBSCRIPTION_OVERRIDES = "Overrides";
